import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {signupToEvent, signoutToEvent, toggleDialogSubscribe, toggleDialogUnsubscribe, setCurrentUserSubscribed} from '../../actions';
import {toggleDrawer} from '../../../Layout/actions';
import Link from 'react-router-dom/Link';
import ReactHtmlParser from 'react-html-parser';
import classnames from 'classnames';
import moment from 'moment';
import 'moment/min/locales';
import 'moment/locale/fr';
import momentDurationFormat from 'moment-duration-format';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_event_details';
import Button from '@material-ui/core/Button';
import UndoIcon from '@material-ui/icons/Undo';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CheckCircleOutlineIcon from '../../assets/img/CheckCircleOutline';
import IconAgepPeople from '../../../Layout/assets/img/icon-agep-people.svg';
import IconAgepClock from '../../../Layout/assets/img/icon-agep-clock.svg';
import IconAgepDoorway from '../../../Layout/assets/img/icon-agep-doorway.svg';
import '../../assets/scss/dialogEventCheckin.css';
import EventDetailsSubscribe from './EventDetailsSubscribe';
import EventDetailsUnsubscribe from './EventDetailsUnsubscribe';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CloseIcon from '@material-ui/icons/Close';
import Drawer from "@material-ui/core/Drawer/Drawer";
import IconInfo2 from '@material-ui/icons/Info';
import {getFirstLastDateSession} from "../../helpers";

class EventDetails extends Component {
    state = {
        mobileInfoDrawerOpen: false,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidMount() {
        const {event} = this.props;

        this.props.setCurrentUserSubscribed(event.currentUserCheckedIn);
    }

    toggleDrawer = (drawer, open) => (e) => {
        e.preventDefault();

        this.props.toggleDrawer(drawer, open);
    };

    toggleInfoDrawer = (open) => () => {
        this.setState({
            mobileInfoDrawerOpen: open,
        });
    };

    render() {
        const {event, signupOrOutLoading} = this.props;
        const {isAuthenticated} = this.props.auth;

        momentDurationFormat(moment);
        moment.locale('fr');

        let idArticle = 'event-' + event.id;

        let title = event.title;
        if (event.title_html !== '' && event.title_html !== null) {
            title = event.title_html;
        }

        let categoryName = '';
        if (Array.isArray(event.types) && event.types.length > 0) {
            // Copy the array (not a reference) => mandatory because we call shift() and that the render() function may be called more than once...
            let copyTypes = event.types.slice(0);
            let category = copyTypes.shift();
            categoryName = category.name;
        }

        let publicStr = '';

        if (Array.isArray(event.publics) && event.publics.length > 0) {
            event.publics.forEach((item, index) => {
                publicStr += item.name + ', ';
            });
            publicStr = publicStr.replace(/,\s*$/, "");
        }

        let multiplePlaces = false;
        if (Array.isArray(event.places) && event.places.length > 1) {
            multiplePlaces = true;
        }

        let thumbnailStyles = {};

        if (event.featured_image && event.featured_image.details) {
            thumbnailStyles = {
                backgroundImage: 'url("' + event.featured_image.details + '")',
            };
        }

        let openCheckin = true;

        let eventDate = getFirstLastDateSession(event.dates);

        console.log(eventDate)


        const nowDatetime = moment().format('YYYY-MM-DD');

        if (event.first_date_from_today !== '') {
            const checkinDeadlineDate = moment(event.first_date_from_today, 'YYYY-MM-DD').subtract(event.checkin_deadline, 'days');
            const checkinDeadlineDatetime = checkinDeadlineDate.format('YYYY-MM-DD');
            if (nowDatetime > checkinDeadlineDatetime) {
                openCheckin = false;
            }
        } else {
            openCheckin = false;
        }

        return (
            <Fragment>
                <article id={idArticle} className="event">
                    <header>
                        <div className="row no-gutters">
                            <div className="col col-left col-4 d-none d-lg-block d-print-flex">
                                <div id="aside">
                                    <div className="inner">
                                        <div className="featured-image" style={thumbnailStyles}></div>
                                        <div className="content">
                                            <address>
                                                {multiplePlaces ? (
                                                    <span className="title">
                                                        <Translate id="event_details.places" />
                                                    </span>
                                                ) : (
                                                    <span className="title">
                                                        <Translate id="event_details.place" />
                                                    </span>
                                                )}

                                                {(Array.isArray(event.places) && event.places.length > 0) ? (
                                                    <Fragment>
                                                        {event.places.map((place, index) => {
                                                            let address = '';

                                                            if (place.address_line1 !== '') {
                                                                address += place.address_line1 + '<br />';
                                                            }
                                                            if (place.address_line2 !== '') {
                                                                address += place.address_line2;
                                                            }
                                                            if (place.address_city !== '') {
                                                                address = address.replace(/^\s*<br\s*\/?>|<br\s*\/?>\s*$/g,''); // Remove last <br/>

                                                                if (address !== '') {
                                                                    address += '<br />';
                                                                }

                                                                if (place.address_postal_code !== '') {
                                                                    address += place.address_postal_code + ' ';
                                                                }
                                                                address += place.address_city;
                                                            }

                                                            return (
                                                                <div key={index} className="place">
                                                                    <span className="place-name">{place.name}</span>
                                                                    <div className="place-address">{ReactHtmlParser(address)}</div>
                                                                    {(place.address_latitude !== '' && place.address_longitude !== '' && place.address_latitude !== "0" && place.address_longitude !== "0") &&
                                                                        <a href={'https://maps.google.com/?q=' + place.address_latitude + ',' + place.address_longitude} target="_blank" className="d-print-none">
                                                                            <Translate id="event_details.view_google_maps" />
                                                                        </a>
                                                                    }
                                                                    {place.remarques && place.remarques !== '' &&
                                                                        <div className="remarques">
                                                                            {ReactHtmlParser(place.remarques)}
                                                                        </div>
                                                                    }
                                                                </div>
                                                            )
                                                        })}
                                                    </Fragment>
                                                ) : (
                                                    <p><Translate id="event_details.place_unknown" /></p>
                                                )}
                                            </address>
                                            {isAuthenticated && eventDate.length > 0 ? (
                                                <Fragment>
                                                    {openCheckin === true ? (
                                                        <Button size="large" className="btn-register" variant="contained" color="primary" onClick={this.props.toggleDialogSubscribe} disabled={signupOrOutLoading}>
                                                            <CheckCircleOutlineIcon className="btn-icon" />
                                                            <Translate id="event_details.button_enroll" />
                                                        </Button>
                                                    ) : (
                                                        <span className="notice-checkin"><Translate id="event_details.notice_enroll_error" /></span>
                                                    )}
                                                </Fragment>
                                            ) : eventDate.length > 0 ? (
                                                <Fragment>
                                                    {openCheckin === true ? (
                                                        <Button size="large" className="btn-register" variant="contained" color="primary" onClick={this.toggleDrawer('signin', true)}>
                                                            <CheckCircleOutlineIcon className="btn-icon" />
                                                            <Translate id="event_details.button_enroll" />
                                                        </Button>
                                                    ) : (
                                                        <span className="notice-checkin"><Translate id="event_details.notice_enroll_error" /></span>
                                                    )}
                                                </Fragment>
                                            ) : null }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-right col-12 col-lg-7 offset-lg-1">
                                <div className="wrapper-top">
                                    <Button size="medium" className="btnBack" component={props => <Link to={this.props.translate('routes.events')} {...props}/>}>
                                        <KeyboardBackspaceIcon className="btnIcon" />
                                        <Translate id="event_details.button_back" />
                                    </Button>

                                    <div className="row row-content no-gutters">
                                        <div className="col col-12 order-lg-1 order-2">
                                            <h1>{ReactHtmlParser(title)}</h1>
                                        </div>
                                        <div className="col col-12 order-lg-2 order-1">
                                            <span className="category">{categoryName}</span>
                                        </div>
                                    </div>

                                    <div id="mobile-featured-image" className="d-block d-lg-none" style={thumbnailStyles}></div>
                                    <div id="mobile-featured-image-layer" className="d-block d-lg-none"></div>
                                </div>

                                <ul className="highlight clearfix">
                                    {(Array.isArray(event.publics) && event.publics.length > 0) &&
                                        <li>
                                            <div className="icon">
                                                <img src={IconAgepPeople} alt="Public" />
                                            </div>
                                            <div className="content">
                                                <span className="title">
                                                    <Translate id="event_details.public" />
                                                </span>
                                                <span className="txt">{ReactHtmlParser(publicStr)}</span>
                                            </div>
                                        </li>
                                    }
                                    {event.duration !== '' &&
                                        <li>
                                            <div className="icon">
                                                <img src={IconAgepClock} alt={this.props.translate('event_details.duration')} />
                                            </div>
                                            <div className="content">
                                                <span className="title">
                                                    <Translate id="event_details.duration" />
                                                </span>
                                                <span className="txt">
                                                    {this.props.translate('event_details.duration_minutes', {time: event.duration})}
                                                </span>
                                            </div>
                                        </li>
                                    }
                                    {event.doors_open_before_duration !== '' &&
                                        <li>
                                            <div className="icon">
                                                <img src={IconAgepDoorway} alt={this.props.translate('event_details.ouverture_portes')} />
                                            </div>
                                            <div className="content">
                                                <span className="title">
                                                    <Translate id="event_details.ouverture_portes" />
                                                </span>
                                                <span className="txt">
                                                    {this.props.translate('event_details.ouverture_portes_minutes', {time: event.doors_open_before_duration})}
                                                </span>
                                            </div>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </header>
                    <div className="row row-content">
                        <div className="col col-right col-12 col-lg-7 offset-lg-5">
                            <section id="description">
                                <h2><Translate id="event_details.description" /></h2>
                                <div className="content">
                                    {ReactHtmlParser(event.content)}
                                </div>
                            </section>
                            <section id="event-dates">
                                <h2><Translate id="event_details.dates" /></h2>
                                <div className="content">
                                    {(Array.isArray(event.dates) && event.dates.length > 0) ? (
                                        <ul className="items clearfix">
                                            {event.dates.map((session, index) => {
                                                let date = moment(session.date, 'YYYY-MM-DD').format('dddd D MMMM YYYY');
                                                let hour = '';
                                                if (session.hour_start !== '' && session.hour_end !== '') {
                                                    hour = this.props.translate('event_details.hours_from_to', {
                                                        from: session.hour_start.substring(0, 5),
                                                        to: session.hour_end.substring(0, 5)
                                                    });
                                                } else if (session.hour_start !== '') {
                                                    hour = session.hour_start.substring(0, 5);
                                                }

                                                return (
                                                    <li key={index} className={classnames('clearfix', {
                                                        'past': (session.date <= nowDatetime),
                                                    })}>
                                                        <span className="left text-capitalize">{date}</span>
                                                        <span className="right">{hour}</span>
                                                        {(session.max_seats > 0 && session.remaining_seats !== null && session.date > nowDatetime) &&
                                                            <div className="remaining_seats">
                                                                {session.remaining_seats === 0 ? (
                                                                    <span><Translate id="event_details.aucun_place_restante" /></span>
                                                                ) : (
                                                                    <span>{this.props.translate('event_details.places_restantes', {places: session.remaining_seats.toString()})}</span>
                                                                )}
                                                            </div>
                                                        }
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    ) : (
                                        <p><Translate id="event_details.no_dates" /></p>
                                    )}
                                </div>
                            </section>
                        </div>
                    </div>
                </article>

                <AppBar position="fixed" className="bottom-tabs">
                    <Tabs fullWidth>
                        <Tab className="dark" label={this.props.translate('event_details.tab_coordonnees')} icon={<IconInfo2 className="btn-icon" />} onClick={this.toggleInfoDrawer(true)} />
                        {isAuthenticated && eventDate.length > 0 ? (
                            <Fragment>
                                {this.props.currentUserSubscribed ? (
                                    <Fragment>
                                        {openCheckin === true ? (
                                            <Tab onClick={this.props.toggleDialogUnsubscribe} label={this.props.translate('event_details.button_disenroll')}
                                                 icon={<CheckCircleOutlineIcon className="btn-icon"/>} disabled={signupOrOutLoading}/>
                                        ) : (
                                            <Tab label={this.props.translate('event_details.notice_disenroll_error')}
                                                 icon={<CheckCircleOutlineIcon className="btn-icon"/>} disabled={true}/>
                                        )}
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        {openCheckin === true && eventDate.length > 0 ? (
                                            <Tab onClick={this.props.toggleDialogSubscribe} label={this.props.translate('event_details.button_enroll')}
                                                 icon={<CheckCircleOutlineIcon className="btn-icon"/>} disabled={signupOrOutLoading}/>
                                        ) : (
                                            <Tab label={this.props.translate('event_details.tab_enroll_close')} disabled={true}/>
                                        )}
                                    </Fragment>
                                )}
                            </Fragment>
                        ) : eventDate.length > 0 ? (
                            <Fragment>
                                {openCheckin === true  ? (
                                    <Tab onClick={this.toggleDrawer('signin', true)} label={this.props.translate('event_details.button_enroll')} icon={<CheckCircleOutlineIcon className="btn-icon"/>} />
                                ) : (
                                    <Tab label={this.props.translate('event_details.tab_enroll_close')} icon={<CheckCircleOutlineIcon className="btn-icon"/>} disabled={true} />
                                )}
                            </Fragment>
                        ) : null }
                    </Tabs>
                </AppBar>

                <Drawer id="info-drawer" anchor="right" open={this.state.mobileInfoDrawerOpen} onClose={this.toggleInfoDrawer(false)} className="header-drawer" classes={{
                    paper: 'header-drawer-paper almost-full info-drawer',
                }}>
                    <div className="wrapper wrapper-top">
                        <div className="inner">
                            <div className="drawer-title">
                                <span className="section"><Translate id="event_details.drawer_info_section" /></span>
                                <h2 className="title"><Translate id="event_details.drawer_info_title" /></h2>
                                <Button size="large" className="btn-close-drawer" onClick={this.toggleInfoDrawer(false)}>
                                    <CloseIcon className="m-icon" />
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="wrapper wrapper-bottom">
                        <div className="inner">
                            <div className="content">
                                <address>
                                    {multiplePlaces ? (
                                        <span className="title">
                                            <Translate id="event_details.places" />
                                        </span>
                                    ) : (
                                        <span className="title">
                                            <Translate id="event_details.place" />
                                        </span>
                                    )}

                                    {(Array.isArray(event.places) && event.places.length > 0) ? (
                                        <Fragment>
                                            {event.places.map((place, index) => {
                                                let address = '';

                                                if (place.address_line1 !== '') {
                                                    address += place.address_line1 + '<br />';
                                                }
                                                if (place.address_line2 !== '') {
                                                    address += place.address_line2;
                                                }
                                                if (place.address_city !== '') {
                                                    address = address.replace(/^\s*<br\s*\/?>|<br\s*\/?>\s*$/g,''); // Remove last <br/>

                                                    if (address !== '') {
                                                        address += '<br />';
                                                    }

                                                    if (place.address_postal_code !== '') {
                                                        address += place.address_postal_code + ' ';
                                                    }
                                                    address += place.address_city;
                                                }

                                                return (
                                                    <div key={index} className="place">
                                                        <span className="place-name">{place.name}</span>
                                                        <div className="place-address">{ReactHtmlParser(address)}</div>
                                                        {(place.address_latitude !== '' && place.address_longitude !== '' && place.address_latitude !== "0" && place.address_longitude !== "0") &&
                                                            <a href={'https://maps.google.com/?q=' + place.address_latitude + ',' + place.address_longitude} target="_blank" className="d-print-none">
                                                                <Translate id="event_details.view_google_maps" />
                                                            </a>
                                                        }
                                                        {place.remarques && place.remarques !== '' &&
                                                            <div className="remarques">
                                                                {ReactHtmlParser(place.remarques)}
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </Fragment>
                                    ) : (
                                        <p><Translate id="event_details.place_unknown" /></p>
                                    )}
                                </address>
                            </div>
                        </div>
                    </div>
                </Drawer>

                <EventDetailsSubscribe event={event} />
                <EventDetailsUnsubscribe event={event} />
            </Fragment>
        );
    }
}

EventDetails.propTypes = {
    auth: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    signupToEvent: PropTypes.func.isRequired,
    signoutToEvent: PropTypes.func.isRequired,
    toggleDrawer: PropTypes.func.isRequired,
    toggleDialogSubscribe: PropTypes.func.isRequired,
    toggleDialogUnsubscribe: PropTypes.func.isRequired,
    setCurrentUserSubscribed: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    layout: state.layout,
    signupOrOutLoading: state.events.eventSignupOrOutLoading,
    currentUserSubscribed: state.events.currentUserSubscribed,
});

export default withRouter(connect(mapStateToProps, {signupToEvent, signoutToEvent, toggleDrawer, toggleDialogSubscribe, toggleDialogUnsubscribe, setCurrentUserSubscribed})(withLocalize(EventDetails)));



// WEBPACK FOOTER //
// ./src/features/Events/components/Details/EventDetails.js